import React, { FC } from 'react'
import ProfileMenuHeader from '../ProfileMenuHeader'
import { Menu } from '../ProfileMenu'

type Props = {
  onClose: any
}

const TermsConditions: FC<Props> = ({ onClose }) => {
  const handleClose = () => {
    onClose(Menu.PROFILE)
  }
  return (
    <div>
      <ProfileMenuHeader
        text="Terms & Conditions"
        onClose={handleClose}
      />
    </div>
  )
}

export default TermsConditions